import { render, staticRenderFns } from "./user-details.vue?vue&type=template&id=319f6c56&scoped=true&"
import script from "./user-details.vue?vue&type=script&lang=js&"
export * from "./user-details.vue?vue&type=script&lang=js&"
import style0 from "./user-details.vue?vue&type=style&index=0&id=319f6c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f6c56",
  null
  
)

export default component.exports